<template>
    <tr>
        <td>
            <div class="cell text-center">
                <div style="width: 250px; display: inline-block;">
                  {{ ssamsType === 'ssamsContentFix'  ? 'SSam SSam 콘텐츠' :'SSam SSam Q&A' }}
                </div>
            </div>
        </td>
        <td>
            <div class="cell text-center">
                <div style="width: 250px; display: inline-block;">
                    <el-radio-group v-model="hasBoardData" style="display: block;">
                        <el-radio :label="1" :value="1" v-if="hasBoardData===1">게시글 고정</el-radio>
                        <el-radio :label="0" :value="0">고정 없음</el-radio>
                    </el-radio-group>
                  <div v-if="boardData !== null && hasBoardData == 1" class="short inline-block" >
                    <el-button @click="openSelectItem(ssamsType)" >
                      변경
                    </el-button>
                  </div>

                  <div v-else class="short inline-block" >
                    <el-button @click="openSelectItem(ssamsType)" >
                      등록
                    </el-button>
                  </div>
                  <div class="short inline-block" v-if="boardData !== null&& hasBoardData == 1">
                    {{boardData.wr_subject}}
                  </div>
                </div>
                </div>
        </td>
      <td>
        <div class="cell text-center">
          <div v-if="boardData != null && hasBoardData == 1"  style="width: 250px; display: inline-block;">
             {{returnUpdateDate(boardData.updated_at)}}
          </div>
        </div>
      </td>
        <td>
          <div class="cell text-center">
            <div style="width: 250px; display: inline-block;">
              <el-button @click="runFix()" class="short inline-block" >
                저장
              </el-button>
            </div>
          </div>
        </td>
    </tr>
    </template>
  
  <script>
  import SsamsWriteLink from "@/components/ssams/link/SsamsWriteLink";
  import ssamsUtil from "@/components/ssams/ssamsUtil";
  import EventBus from "@/utils/event-bus";
  import util from "@/mixins/util";
  import alertMixins from "@/mixins/alertMixins";
  import ssamsValidator from "@/components/ssams/ssamsValidator";
  import DeleteClass from "@/mixins/deleteClass";
  import elFileMixins from "@/mixins/elFileMixins";
  import dateMixins from "@/mixins/dateMixins";
  export default {
    name: "SsamsFixDetailComponent",
    mixins: [alertMixins, ssamsUtil, elFileMixins, ssamsValidator, dateMixins],
    components: { SsamsWriteLink },
    inject: [],
    provide() {
      return {
        ssamsWriteSetData: this.setData,
      };
    },
    props: {
      ssamsType: { default: "" },
      ssamsKey: { default: 0 },
      boardData: null
    },
    data() {
      return {
        ssamsData: {},
        detailApiParamSet: {},
        writeLayouts: [],
        writeFunc: "",
        writeApiParamSet: {},
        parsingData: {},
        fileType: "",
        directUrl: "",
        directType: "",
        keyName: "",
        writeSuccessType: 1,
        writeSuccessMsg: "작성되었습니다.",
        writeFailTypes: {},
        writeFailMsg: "",
        isRunning: false,
        deleteFunc: "",
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
        DeleteClass: null,
        hasBoardData : 0,
        hasInitialData : false
      };
    },
    beforeRouterEnter() {},
    created() {
      this.initFilterConfig();
    },
    mounted() {
      this.init();
      EventBus.$on(`${this.ssamsType}ChooseItem`, this.selectFixData);

    },
    beforeDestroy() {
      EventBus.$off(`${this.ssamsType}ChooseItem`)
    },
    destroyed() {},
    computed: {},
    methods: {
      setData(key, value) {
        this[key] = value;
      },
      initFilterConfig() {
        let config = this.returnSsamsConfig(this.ssamsType);
        this.detailApiParamSet = config.detailApiParamSet;
        this.writeFunc = config.writeFunc;
        this.writeApiParamSet = config.writeApiParamSet;
        this.parsingData = config.parsingData;
        this.directUrl = config.directUrl;
        this.directType = config.directType;
        this.keyName = config.keyName;
        this.writeSuccessType = config.writeSuccessType;
        this.writeSuccessMsg = util.isEmpty(config.writeSuccessMsg) ? this.writeSuccessMsg : config.writeSuccessMsg;
        this.writeFailTypes = config.writeFailTypes;
        this.writeFailMsg = config.writeFailMsg;
        this.deleteFunc = config.deleteFunc;
        this.deleteApiParamsSet = config.deleteApiParamsSet;
        this.deleteSuccessType = config.deleteSuccessType;
        this.deleteFailTypes = config.deleteFailTypes;
        this.newDeleteClass();
      },
      _checkValidator() {
        let validatorArr = Object.keys(this.parsingData);
        return this.$validate(validatorArr).then((success) => {
          if (!success) {
            this.errorAlert("필수데이터를 확인해주세요.");
              util.Array.each(this.writeLayouts, (layout, index, arr) => {
              this.checkValidator(validatorArr)
            });
            return success;
          }
          return success;
        });
      },
      _makeParams() {
        let params = Object.assign({}, this.writeApiParamSet);
        util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
          params[paramKey] = this[dataKey];
        });
        return params;
      },
      returnWriteType(type) {
        if (type === this.writeSuccessType) {
          return true;
        } else {
          return util.isEmpty(this.writeFailTypes[type])
            ? "저장 실패했습니다."
            : this.writeFailTypes[type];
        }
      },
      afterFunc() {
        EventBus.$emit("apiLoading", false);
        let content = '저장이 완료되었습니다.';
        this.createAlert({
          content: content,
          hide: () => {
            if (this.directType === "back") {
              this.$router.back();
              EventBus.$emit("apiLoading", false);
              return false;
            }
            if (this.directUrl === "") {
              this.writeLayouts = [];
              this.deleteFiles = [];
              EventBus.$emit("apiLoading", false);
              return false;
            }
            EventBus.$emit("apiLoading", false);
            let url = this.directUrl;
            this.$router.push(url);
          },
        });
      },
      newDeleteClass() {
        if (!util.isEmpty(this.deleteFunc)) {
          let deleteOptions = {
            func: this.$api.$ssams[this.deleteFunc],
            apiParamSet: this.deleteApiParamsSet,
            keyName: this.keyName,
            successType: this.deleteSuccessType,
            errorTypes: this.deleteFailTypes,
            afterFunc: this.deleteAfterFunc,
          };
          this.DeleteClass = new DeleteClass(deleteOptions);
        }
      },
      runFix() {
        this.createConfirm({
          content: "변동사항에 대해서 저장하시겠습니까?",
          confirmText: "확인",
          confirm: () => {
            this.hasBoardData === 0 ? this.runDelete() : this.runWrite();
          },
        });
      },
      runDelete() {
        EventBus.$emit("apiLoading", true);
        this.DeleteClass.runDelete(this.ssamsKey);
      },
      deleteAfterFunc() {
        EventBus.$emit("apiLoading", false);
        this.createAlert({
          content: "저장이 완료되었습니다.",
          hide: () => {
            this.$router.back();
          },
        });
      },
      async runWrite(){
        if (this.isRunning) {
          return false;
        }
        this.isRunning = true;
        let validator = await this._checkValidator();
        if (!validator) {
          this.isRunning = false;
          return false;
        }
        EventBus.$emit("apiLoading", true);
        let params = this._makeParams();
        console.log(params);
        try {
          this.$api.$ssams[this.writeFunc](params)
              .then((res) => res.Data.Result)
              .then((res) => {
                let type = this.returnWriteType(res.Info.type);
                if (type !== true) {
                  this.errorAlert(type);
                  EventBus.$emit("apiLoading", false);
                  return (this.isRunning = false);
                }
                this.afterFunc();
                EventBus.$emit("apiLoading", false);
              });
        } catch (e) {
          console.log(e);
          this.isRunning = false;
          EventBus.$emit("apiLoading", false);
        }
      },
      init(){
        if(!util.isEmpty(this.boardData)){
          this.hasInitialData = !util.isEmpty(this.boardData.s_idx) ? true : false;
          this.setData('sid', this.boardData.s_idx);
          this.setData('wid', this.boardData.wr_id);
        }
        this.hasInitialData = !util.isEmpty(this.boardData) && !util.isEmpty(this.boardData.s_idx)? true : false;
        this.hasData()
      },
      hasData(){
        if(!util.isEmpty(this.boardData)){
          this.hasBoardData = 1;
        }else{
          this.hasBoardData = 0;
        }
      },
      openSelectItem(boardType){
        this.$modal.show('item-one-select-modal', {boardType : boardType, emitName: `${this.ssamsType}ChooseItem`});
      },
      selectFixData(fixData){
        this.boardData = fixData.fixBoard
        this.setData('sid', this.boardData.s_idx);
        this.setData('wid', this.boardData.wr_id);
        this.hasData();
      },
      checkValidator(dataArr) {
        this.$validate(dataArr)
      },
      returnUpdateDate(update){
        if(typeof update === "number"){
          return this.returnDateUnix(update);
        }else{
          return '-'
        }
      }
    },
    watch: {

    },
  };
  </script>
  
  <style scoped></style>
  